'use strict';
// Empty since it's loaded before $ is instantiated